import React from 'react';

/**
 * LoadingSkeleton (simple page/content skeleton)
 * Params:
 * - lines: number (default 3)
 * - showAvatar: boolean
 * - showImage: boolean
 * - className: string (optional wrapper classes)
 */
export const LoadingSkeleton = ({ lines = 3, showAvatar = false, showImage = false, className = '' }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      {showAvatar && (
        <div className="flex items-center space-x-4 mb-4">
          <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      )}
      {showImage && <div className="w-full h-48 bg-gray-300 rounded-lg mb-4"></div>}
      <div className="space-y-3">
        {Array.from({ length: lines }).map((_, index) => (
          <div key={index} className={`h-4 bg-gray-300 rounded ${index === 0 ? 'w-3/4' : index === 1 ? 'w-1/2' : 'w-5/6'}`}></div>
        ))}
      </div>
    </div>
  );
};


